import { createAction } from '../../../utils/redux/createAction';

const actionsScope = 'paperwork/common';

export const PAPERWORK_COMMON_ACTION_TYPES = {
  GLOBAL_PAPERWORK_PENDING: `${actionsScope}/global-paperwork-pending`,
  PAPERWORK_PAGE_INFO: `${actionsScope}/page-info`,
  SET_PAPERWORK_CAME_FROM_SUBMIT_PAGE: `${actionsScope}/set-paperwork-came-from-submit-page`,
  SET_PAPERWORK_INSURANCE_IS_PLAN_NOT_LISTED_SELECTED: `${actionsScope}/set-paperwork-insurance-is-plan-not-listed-selected`,
  SET_PAPERWORK_ADDITIONAL_INFO_FORM_DATA: `${actionsScope}/set-paperwork-additional-info-form-data`,
  GLOBAL_PAPERWORK_VALIDATING: `${actionsScope}/global-paperwork-validating`,
  VALIDATE: `${actionsScope}/validate`,
  DETERMINE_PAPERWORK_FLOW_ROUTES: `${actionsScope}/determine-paperwork-flow-routes`,
};

export const paperworkCommonActions = {
  setGlobalPaperworkPending: createAction(
    PAPERWORK_COMMON_ACTION_TYPES.GLOBAL_PAPERWORK_PENDING,
  ),
  setPaperworkPageInfo: createAction(
    PAPERWORK_COMMON_ACTION_TYPES.PAPERWORK_PAGE_INFO,
  ),
  setPaperworkCameFromSubmitPage: createAction(
    PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_CAME_FROM_SUBMIT_PAGE,
  ),
  setPaperworkInsuranceIsPlanNotListedSelected: createAction(
    PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_INSURANCE_IS_PLAN_NOT_LISTED_SELECTED,
  ),
  setPaperworkAdditionalInfoFormData: createAction(
    PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_ADDITIONAL_INFO_FORM_DATA,
  ),

  setGlobalPaperworkValidating: createAction(
    PAPERWORK_COMMON_ACTION_TYPES.GLOBAL_PAPERWORK_VALIDATING,
  ),
  validate: createAction(PAPERWORK_COMMON_ACTION_TYPES.VALIDATE),
  determinePaperworkFlowRoutes: createAction(
    PAPERWORK_COMMON_ACTION_TYPES.DETERMINE_PAPERWORK_FLOW_ROUTES,
  ),
};



// WEBPACK FOOTER //
// ./src/redux/paperwork/actions/common.js